<template>
  <div>
    <div class="row">
      <div class="col-6">
        <custom-drop-down
          id="serviceSpecialist"
          class="mb-4"
          v-model="specialist"
          disabled
          fieldkey="id"
          fieldname="name"
          label="Especialista de Servicio:"
          name="serviceSpecialist"
          :options="[specialist]"
        />
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <custom-drop-down
          id="writerSpecialist"
          class="mb-4"
          v-model="writer"
          disabled
          fieldkey="id"
          fieldname="name"
          label="Persona que redactó el plan:"
          name="writerSpecialist"
          :options="[writer]"
        />
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="color-secondary-6 font-14">
          Especialista de Servicio:
        </div>
        <span class="color-black font-16 font-weight-bold">
          {{ specialist.name }}
        </span>
      </div>
      <div class="col-md-4">
        <div class="color-secondary-6 font-14">
          Numero de Licencia:
        </div>
        <span class="color-black font-16">
          {{ specialist.licenseNumber }}
        </span>
      </div>
      <div class="col-md-4">
        <div class="color-secondary-6 font-14">
          Fecha de Expiración:
        </div>
        <span class="color-black font-16">
          {{ specialist.licenseExpiration }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import moment from 'moment';
export default {
  name: 'PlanSpecialist',
  components: {
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        serviceSpecialistId: null,
        serviceSpecialistName: null,
        specialistLicenseNumber: null,
        specialistLicenseExpiration: null,
        writerSpecialistId: null,
        writerSpecialistName: null,
      }),
    },
  },
  data() {
    return {
      specialist: {
        id: null,
        name: null,
        licenseNumber: null,
        licenseExpiration: null,
      },
      writer: {
        id: null,
        name: null,
      },
    };
  },
  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.specialist = {
          id: newValue.serviceSpecialistId,
          name: newValue.serviceSpecialistName,
          licenseNumber: newValue.specialistLicenseNumber,
          licenseExpiration: moment(newValue.specialistLicenseExpiration)
            .locale('es-PR')
            .format('DD/MMM/YYYY'),
        };

        this.writer = {
          id: newValue.writerSpecialistId,
          name: newValue.writerSpecialistName,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
